module.exports = __webpack_public_path__ + "img/mine.bf946905.png";